import {
  GET_LAW_TASKS,
  GET_LAW_TASK,
  CREATE_LAW_TASK,
  UPDATE_LAW_TASK,
  DELETE_LAW_TASK
} from '../actions/lawTaskActions';

const initialState = {
  tasks: [],
  task: null,
  numberOfPages: 0,
  currentPage: 1,
  isLoading: false
};

const lawTaskReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LAW_TASKS:
      return {
        ...state,
        tasks: action.payload.tasks || action.payload,
        numberOfPages: action.payload.totalPages || 0,
        currentPage: action.payload.currentPage || 1,
        isLoading: false
      };

    case GET_LAW_TASK:
      return {
        ...state,
        task: action.payload,
        isLoading: false
      };

    case CREATE_LAW_TASK:
      return {
        ...state,
        tasks: [action.payload, ...state.tasks]
      };

    case UPDATE_LAW_TASK:
      return {
        ...state,
        tasks: state.tasks.map(task =>
          task._id === action.payload._id ? action.payload : task
        ),
        task: action.payload
      };

    case DELETE_LAW_TASK:
      return {
        ...state,
        tasks: state.tasks.filter(task => task._id !== action.payload)
      };

    default:
      return state;
  }
};

export default lawTaskReducer;
